import React, { useMemo, useState } from "react";
import { useIntl, getLocale, useSelector } from 'umi'
import { formatNum, getUpAndDownStatus, getWeekDay, getDynamicLocalCnEnText } from "@/pages/dashboard/utils/utils";
import { useWeekDayArr } from "@/pages/dashboard/utils/customHook";
import {  getVal } from "@/pages/dashboard/pages/comparison/_config/utils";
import { getCountryFlag } from '@/pages/home/_config/countries';
import MetricAndUpDown from "@/pages/dashboard/components/MetricAndUpDown";
import moment from "moment";
import { ACCUMULATED_DEFAULT_VALUE } from "@/pages/dashboard/components/Accumulate";
import { getMonetUnit } from "@/pages/dashboard/utils/moneyUnit";
import getMetricColumn from "@/pages/dashboard/utils/getMetricColumn";
import { getExplainVal } from "@/pages/dashboard/utils/getExplainVal";
import { Bubble } from "tea-component";
import SvgIcon from "@/pages/home/components/SvgIcon";

export const useTopCardList = (timeType = 'Day',pageShowType:string) => {
  const {
    formatMessage
  } = useIntl();
  const topCardList = useMemo(() => {
    // 做这个配置是为了页面中减少日周月，品均值的判断逻辑，也能页面统一指标的展示和名称
    // 这么多配置是因为名称和后端返回的字段，会根据日周月、平均值等进行变化
    // info信息按理说要单独配一个字段用以获取info的，但是页面中指标展示的名称刚好和后端info信息的key值一致，所以不做单独配置
    // indicatorsName是做下钻指标继承时添加的，为了和之前页面的指标名称对齐
    const mobileMetrics = {
      Day: [
        // 日
        {
          id: 'TRU',
          indicatorsName: 'tru',
          resName: 'total_users',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_TRU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'New',
          indicatorsName: 'new',
          resName: 'new_users',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_New'
          }),
          // weekName: formatMessage({
          //     id: 'overview_monthly_New'
          // }),
          // monthName: formatMessage({
          //     id: 'overview_monthly_New'
          // }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        }, //非用户类，保留两位小数，bmk保留两位小数

        {
          id: 'DAU',
          indicatorsName: 'dau',
          resName: 'active_users',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_DAU'
          }),
          // weekName: formatMessage({
          //     id: 'overview_weekly_WAU'
          // }),
          // monthName: formatMessage({
          //     id: 'overview_monthly_MAU'
          // }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        }, //用户类 ，bmk保留两位小数


        {
          id: 'Revenue',
          indicatorsName: 'revenue',
          resName: 'pay_amount',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },


        {
          id: 'PCU',
          indicatorsName: 'pcu',
          resName: 'pcu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_PCU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'ACU',
          indicatorsName: 'acu',
          resName: 'acu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ACU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Avg.Playtime(min)',
          indicatorsName: 'aot',
          resName: 'aot',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_AOT(min)'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'D2',
          resName: 'd2',
          indicatorsName: 'd237',
          // resWeekName: 'active_users_w2',
          // resMonthName: 'active_users_m2',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D2'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D3',
          resName: 'd3',
          indicatorsName: 'd3',
          // resWeekName: 'active_users_w3',
          // resMonthName: 'active_users_m3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D3'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D4',
          resName: 'd4',
          indicatorsName: 'd4',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D4'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'D5',
          resName: 'd5',
          indicatorsName: 'd5',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D5'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D6',
          resName: 'd6',
          indicatorsName: 'd6',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D6'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D7',
          resName: 'd7',
          indicatorsName: 'd7',
          // resWeekName: 'active_users_w7',
          // resMonthName: 'active_users_m7',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D7'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Payer',
          resName: 'paid_users',
          indicatorsName: 'payer',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Payer%',
          resName: 'payer_rate',
          indicatorsName: 'payer_ratio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Payer%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'ARPU',
          resName: 'arpu',
          indicatorsName: 'arpu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ARPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'ARPPU',
          resName: 'arppu',
          indicatorsName: 'arppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },



        {
          id: 'New Payer',
          resName: 'new_paid_users',
          indicatorsName: 'newPayer',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        // {
        //   id: 'Register Payer',
        //   resName: 'register_paid_users',
        //   resAvgName: '',
        //   name: formatMessage({
        //     id: 'overview_Register_Payer'
        //   }),
        //   avgName: '',
        //
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: true,
        //   dodDecimals: 1
        // },
        {
          id: 'Revenue(new payer)',
          resName: 'new_pay_amount',
          indicatorsName: 'revenue',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue(new_payer)'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'New Users ARPPU($)',
          resName: 'new_arppu',
          indicatorsName: 'newArppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Users_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        //
        {
          id: 'Sessions per user',
          resName: 'alc',
          indicatorsName: 'alc',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Avg.Login_Count'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },


        {
          id: 'DAU Retention Users',
          resName: 'retention_users',
          indicatorsName: 'retentionUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_DAU_Retention_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Churn Users',
          resName: 'churn_users',
          indicatorsName: 'churnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Churn_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Churn%',
          resName: 'churn_rate',
          indicatorsName: 'churnRate',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Churn%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'DAU Return Users',
          resName: 'return_users',
          indicatorsName: 'returnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_DAU_Return_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },


        {
          id: 'Weighted D2',
          resName: 'weighted_d2',
          indicatorsName: 'weighted_d2',
          // resWeekName: 'weighted_w2',
          // resMonthName: 'weighted_m2',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D2'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D3',
          resName: 'weighted_d3',
          indicatorsName: 'weighted_d3',
          // resWeekName: 'weighted_w3',
          // resMonthName: 'weighted_m3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D3'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D7',
          resName: 'weighted_d7',
          indicatorsName: 'weighted_d7',
          // resWeekName: 'weighted_w7',
          // resMonthName: 'weighted_m7',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D7'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Weighted D14',
          resName: 'weighted_d14',
          indicatorsName: 'weightedD14',
          // resWeekName: 'weighted_w14',
          // resMonthName: 'weighted_m14',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D14'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: '1st Order Login%',
          resName: 'first_login_ratio',
          indicatorsName: 'firstLoginRatio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_1st_Order_Login%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: '2nd Order Login%',
          resName: 'second_login_ratio',
          indicatorsName: 'secondLoginRatio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_2nd_Order_Login%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        // 日结束


      ],
      Week: [
        {
          id: 'TRU',
          resName: 'total_users',
          indicatorsName: 'tru',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_TRU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'New',
          resName: 'new_users',
          indicatorsName: 'new',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_New'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        }, //非用户类，保留两位小数，bmk保留两位小数


        {
          id: 'Avg.Daily New',
          resName: 'avg_new_users',
          indicatorsName: 'avgNewUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Avg.Daily_New'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'WAU',
          resName: 'active_users',
          indicatorsName: 'wau',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_WAU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        }, //用户类 ，bmk保留两位小数

        {
          id: 'Week Avg.DAU',
          resName: 'avg_active_users',
          indicatorsName: 'avg.wau',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Week_Avg.DAU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Revenue',
          resName: 'pay_amount',
          indicatorsName: 'revenue',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Week Avg.Revenue($)',
          resName: 'avg_pay_amount',
          indicatorsName: 'avgPayAmount',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Week_Avg.Revenue($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },


        {
          id: 'PCU',
          resName: 'pcu',
          indicatorsName: 'pcu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_PCU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'ACU',
          resName: 'acu',
          indicatorsName: 'acu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ACU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Avg.Playtime(min)',
          resName: 'aot',
          indicatorsName: 'aot',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_AOT(min)'
          }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Avg.Daily Playtime(min)',
          resName: 'saot',
          indicatorsName: 'saot',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Avg_Daily_Playtime(min)'
          }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'W2',
          resName: 'w2',
          indicatorsName: 'w23',
          // resWeekName: 'active_users_w2',
          // resMonthName: 'active_users_m2',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_W2'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'W3',
          resName: 'w3',
          indicatorsName: 'w3',
          // resWeekName: 'active_users_w3',
          // resMonthName: 'active_users_m3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_W3'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'W4',
          resName: 'w4',
          indicatorsName: 'w4',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_W4'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Payer',
          resName: 'paid_users',
          indicatorsName: 'payer',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Payer%',
          resName: 'payer_rate',
          indicatorsName: 'payer_ratio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Payer%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'ARPU',
          resName: 'arpu',
          indicatorsName: 'arpu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ARPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'ARPPU',
          resName: 'arppu',
          indicatorsName: 'arppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },



        {
          id: 'New Payer',
          resName: 'new_paid_users',
          indicatorsName: 'newPaidUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        // {
        //   id: 'Register Payer',
        //   resName: 'register_paid_users',
        //   resAvgName: '',
        //   name: formatMessage({
        //     id: 'overview_Register_Payer'
        //   }),
        //   avgName: '',
        //
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: true,
        //   dodDecimals: 1
        // },
        {
          id: 'Revenue(new payer)',
          resName: 'new_pay_amount',
          indicatorsName: 'newPayAmount',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue(new_payer)'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'New Users ARPPU($)',
          resName: 'new_arppu',
          indicatorsName: 'newArppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Users_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Sessions per user',
          resName: 'alc',
          indicatorsName: 'alc',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Avg.Login_Count'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },


        {
          id: 'WAU Retention Users',
          resName: 'retention_users',
          indicatorsName: 'retentionUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_WAU_Retention_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Churn Users',
          resName: 'churn_users',
          indicatorsName: 'churnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Churn_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Churn%',
          resName: 'churn_rate',
          indicatorsName: 'churnRate',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Churn%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'WAU Return Users',
          resName: 'return_users',
          indicatorsName: 'returnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_WAU_Return_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },


        {
          id: 'Weighted W2',
          resName: 'weighted_w2',
          indicatorsName: 'weighted_w2',
          // resWeekName: 'weighted_w2',
          // resMonthName: 'weighted_m2',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Weighted_W2'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted W3',
          resName: 'weighted_w3',
          indicatorsName: 'weighted_w3',
          // resWeekName: 'weighted_w3',
          // resMonthName: 'weighted_m3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Weighted_W3'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted W4',
          resName: 'weighted_w4',
          indicatorsName: 'weighted_w4',
          // resWeekName: 'weighted_w7',
          // resMonthName: 'weighted_m7',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_weekly_Weighted_W4'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

      ],
      Month: [
        {
          id: 'TRU',
          resName: 'total_users',
          indicatorsName: 'tru',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_TRU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'New',
          resName: 'new_users',
          indicatorsName: 'new',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_New'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        }, //非用户类，保留两位小数，bmk保留两位小数


        {
          id: 'Avg.Daily New',
          resName: 'avg_new_users',
          indicatorsName: 'avgNewUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Avg.Daily_New'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'MAU',
          resName: 'active_users',
          indicatorsName: 'mau',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_MAU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        }, //用户类 ，bmk保留两位小数

        {
          id: 'Month Avg.DAU',
          resName: 'avg_active_users',
          indicatorsName: 'avg.mau',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Month_Avg.DAU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Revenue',
          resName: 'pay_amount',
          indicatorsName: 'revenue',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Month Avg.Revenue($)',
          resName: 'avg_pay_amount',
          indicatorsName: 'avgPayAmount',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Month_Avg.Revenue($)'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },


        {
          id: 'PCU',
          resName: 'pcu',
          indicatorsName: 'pcu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_PCU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'ACU',
          resName: 'acu',
          indicatorsName: 'acu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ACU'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Avg.Playtime(min)',
          resName: 'aot',
          indicatorsName: 'aot',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_AOT(min)'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'M2',
          resName: 'm2',
          indicatorsName: 'm23',
          // resWeekName: 'active_users_w2',
          // resMonthName: 'active_users_m2',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Month_M2'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'M3',
          resName: 'm3',
          indicatorsName: 'm3',
          // resWeekName: 'active_users_w3',
          // resMonthName: 'active_users_m3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Month_M3'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'M4',
          resName: 'm4',
          indicatorsName: 'm4',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Month_M4'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Payer',
          resName: 'paid_users',
          indicatorsName: 'payer',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Payer%',
          resName: 'payer_rate',
          indicatorsName: 'payer_ratio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Payer%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'ARPU',
          resName: 'arpu',
          indicatorsName: 'arpu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ARPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'ARPPU',
          resName: 'arppu',
          indicatorsName: 'arppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },



        {
          id: 'New Payer',
          resName: 'new_paid_users',
          indicatorsName: 'newPaidUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        // {
        //   id: 'Register Payer',
        //   resName: 'register_paid_users',
        //   resAvgName: '',
        //   name: formatMessage({
        //     id: 'overview_Register_Payer'
        //   }),
        //   avgName: '',
        //
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: true,
        //   dodDecimals: 1
        // },
        {
          id: 'Revenue(new payer)',
          resName: 'new_pay_amount',
          indicatorsName: 'newPayAmount',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue(new_payer)'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'New Users ARPPU($)',
          resName: 'new_arppu',
          indicatorsName: 'newArppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Users_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'Sessions per user',
          resName: 'alc',
          indicatorsName: 'alc',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Avg.Login_Count'
          }),
          avgName: '',

          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'MAU Retention Users',
          resName: 'retention_users',
          indicatorsName: 'retentionUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_MAU_Retention_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'Churn Users',
          resName: 'churn_users',
          indicatorsName: 'churnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Churn_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Churn%',
          resName: 'churn_rate',
          indicatorsName: 'churnRate',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Churn%'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'MAU Return Users',
          resName: 'return_users',
          indicatorsName: 'returnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_MAU_Return_Users'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },


        {
          id: 'Weighted M2',
          resName: 'weighted_m2',
          indicatorsName: 'weighted_m2',
          // resWeekName: 'weighted_w2',
          // resMonthName: 'weighted_m2',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Weighted_M2'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted M3',
          resName: 'weighted_m3',
          indicatorsName: 'weighted_m3',
          // resWeekName: 'weighted_w3',
          // resMonthName: 'weighted_m3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Weighted_M3'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted M4',
          resName: 'weighted_m4',
          indicatorsName: 'weighted_m4',
          // resWeekName: 'weighted_w7',
          // resMonthName: 'weighted_m7',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_Weighted_M4'
          }),
          avgName: '',

          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

      ]
    }
    const pcMetrics = {
      Day: [
        // 日
        // {
        //   id: 'Entitlement',
        //   indicatorsName: 'all_entitlement',
        //   resName: 'all_entitlement',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_Entitlement' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 0,
        //   isUserType: true,
        //   dodDecimals: 1
        // },
        {
          id: 'TRU',
          indicatorsName: 'total_users',
          resName: 'total_users',
          resAvgName: '',
          name: formatMessage({ id: 'overview_TRU' }),
          rainbowKey: 'Pc TNU',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'New',
          indicatorsName: 'new_users',
          resName: 'new_users',
          resAvgName: '',
          name: formatMessage({ id: 'overview_New' }),
          rainbowKey: 'Pc New',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'DAU',
          indicatorsName: 'active_users',
          resName: 'active_users',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_DAU' }),
          rainbowKey: 'Pc DAU',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Revenue',
          indicatorsName: 'net_revenue',
          resName: 'net_revenue',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_Revenue($)' }, { unit: getMonetUnit() }),
          rainbowKey: 'Pc Revenue',
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Units',
          indicatorsName: 'units_number',
          resName: 'units_number',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_Units' }),
          rainbowKey: 'Pc Units',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Units Revenue',
          indicatorsName: 'units_revenue',
          resName: 'units_revenue',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_Units_Revenue' }),
          rainbowKey: 'Pc Units Revenue',
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        // {
        //   id: 'DLC Revenue',
        //   indicatorsName: 'dlc_revenue',
        //   resName: 'dlc_revenue',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_DLC_Revenue' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        {
          id: 'In-Game Revenue',
          indicatorsName: 'mtx_revenue',
          resName: 'mtx_revenue',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_Revenue' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        // {
        //   id: 'Payer',
        //   indicatorsName: 'paid_users',
        //   resName: 'paid_users',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'overview_Payer' }),
        //   rainbowKey: 'Pc Payer',
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 0,
        //   isUserType: true,
        //   dodDecimals: 1
        // },
        // {
        //   id: 'Payer%',
        //   indicatorsName: 'payer_rate',
        //   resName: 'payer_rate',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'overview_Payer%' }),
        //   isPercent: true,
        //   decimals: 2,
        //   dodDecimals: 1,
        //   avgName: '',
        //   isUserType: false,
        // },
        // {
        //   id: 'MTX',
        //   indicatorsName: 'mtx_number',
        //   resName: 'mtx_number',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_MTX' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 0,
        //   isUserType: true,
        //   dodDecimals: 1
        // },
        // {
        //   id: 'ARPU',
        //   indicatorsName: 'arpu',
        //   resName: 'arpu',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'overview_ARPU($)' }, { unit: getMonetUnit() }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        // {
        //   id: 'ARPPU',
        //   indicatorsName: 'arppu',
        //   resName: 'arppu',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'overview_ARPPU($)' }, { unit: getMonetUnit() }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        {
          id: 'In-Game Payer',
          indicatorsName: 'mtx_payers',
          resName: 'mtx_payers',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_Payer' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'In-Game Payer%',
          indicatorsName: 'mtx_payer_rate',
          resName: 'mtx_payer_rate',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_Payer_Rate' }),
          isPercent: true,
          decimals: 2,
          dodDecimals: 1,
          avgName: '',
          isUserType: false,
        },
        // {
        //   id: 'DLC & In-Game ARPU',
        //   indicatorsName: 'mtx_dlc_arpu',
        //   resName: 'mtx_dlc_arpu',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_DLC_MTX_ARPU' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        {
          id: 'In-Game ARPU',
          indicatorsName: 'mtx_arpu',
          resName: 'mtx_arpu',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_ARPU' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        // {
        //   id: 'DLC & In-Game ARPPU',
        //   indicatorsName: 'mtx_dlc_arppu',
        //   resName: 'mtx_dlc_arppu',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_DLC_MTX_ARPPU' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        {
          id: 'In-Game ARPPU',
          indicatorsName: 'mtx_arppu',
          resName: 'mtx_arppu',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_ARPPU' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        // {
        //   id: 'Digital Revenue',
        //   indicatorsName: 'digital_revenue',
        //   resName: 'digital_revenue',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_Digital_Revenue' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        // {
        //   id: 'Physical Revenue',
        //   indicatorsName: 'physical_revenue',
        //   resName: 'physical_revenue',
        //   resAvgName: '',
        //   name: formatMessage({ id: 'pc_overview_Physical_Revenue' }),
        //   avgName: '',
        //   isPercent: false,
        //   decimals: 2,
        //   isUserType: false,
        //   dodDecimals: 1
        // },
        {
          id: 'Time to Purchase (days)',
          indicatorsName: 'avg_time_to_purchase',
          resName: 'avg_time_to_purchase',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_Time_to_Purchase' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D1',
          indicatorsName: 'd1',
          resName: 'd1',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_daily_D1' }),
          rainbowKey: 'Pc D1',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D2',
          indicatorsName: 'd2',
          resName: 'd2',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_daily_D2' }),
          rainbowKey: 'Pc D2',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D3',
          indicatorsName: 'd3',
          resName: 'd3',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D3' }),
          rainbowKey: 'Pc D3',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D4',
          indicatorsName: 'd4',
          resName: 'd4',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D4' }),
          rainbowKey: 'Pc D4',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D5',
          indicatorsName: 'd5',
          resName: 'd5',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D5' }),
          rainbowKey: 'Pc D5',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D6',
          indicatorsName: 'd6',
          resName: 'd6',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D6' }),
          rainbowKey: 'Pc D6',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D7',
          indicatorsName: 'd7',
          resName: 'd7',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D7' }),
          rainbowKey: 'Pc D7',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D14',
          indicatorsName: 'd14',
          resName: 'd14',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D14' }),
          rainbowKey: 'Pc D14',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D30',
          indicatorsName: 'd30',
          resName: 'd30',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_D30' }),
          rainbowKey: 'Pc D30',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'PCU',
          indicatorsName: 'pcu',
          resName: 'pcu',
          resAvgName: '',
          name: formatMessage({ id: 'overview_PCU' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'ACU',
          indicatorsName: 'acu',
          resName: 'acu',
          resAvgName: '',
          name: formatMessage({ id: 'overview_ACU' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Avg.Playtime(min)',
          indicatorsName: 'aot',
          resName: 'aot',
          resAvgName: '',
          name: formatMessage({ id: 'overview_AOT(min)' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Sessions per user',
          indicatorsName: 'alc',
          resName: 'alc',
          resAvgName: '',
          name: formatMessage({ id: 'overview_Avg.Login_Count' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'DAU Retention Users',
          indicatorsName: 'retention_users',
          resName: 'retention_users',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_DAU_Retention_Users' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Churn Users',
          indicatorsName: 'churn_users',
          resName: 'churn_users',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_Churn_Users' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Churn%',
          indicatorsName: 'churn_rate',
          resName: 'churn_rate',
          resAvgName: '',
          name: formatMessage({ id: 'overview_Churn%' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'DAU Return Users',
          indicatorsName: 'return_users',
          resName: 'return_users',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_DAU_Return_Users' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Weighted D2',
          indicatorsName: 'weighted_d2',
          resName: 'weighted_d2',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_Weighted_D2' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D3',
          indicatorsName: 'weighted_d3',
          resName: 'weighted_d3',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_Weighted_D3' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D7',
          indicatorsName: 'weighted_d7',
          resName: 'weighted_d7',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_Weighted_D7' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D14',
          indicatorsName: 'weighted_d14',
          resName: 'weighted_d14',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_Weighted_D14' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: '1st Order Login%',
          indicatorsName: 'first_login_ratio',
          resName: 'first_login_ratio',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_1st_Order_Login%' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: '2nd Order Login%',
          indicatorsName: 'second_login_ratio',
          resName: 'second_login_ratio',
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_2nd_Order_Login%' }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
      ],
    }

    const inflexionMetrics = {
      Day: [
        {
          id: 'DAU',
          indicatorsName: 'dau',
          resName: 'active_users',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_DAU'
          }),
          rainbowKey: 'Pc DAU',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'New',
          indicatorsName: 'new',
          resName: 'new_users',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_monthly_New'
          }),
          rainbowKey: 'Pc New',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'TRU',
          indicatorsName: 'tru',
          resName: 'total_users',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_TRU'
          }),
          rainbowKey: 'Pc TNU',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Revenue',
          indicatorsName: 'revenue',
          resName: 'revenue',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue($)'
          }, { unit: getMonetUnit() }),
          rainbowKey: 'Pc Revenue',
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'PCU',
          indicatorsName: 'pcu',
          resName: 'pcu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_PCU'
          }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'ACU',
          indicatorsName: 'acu',
          resName: 'acu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_ACU'
          }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Avg.Playtime(min)',
          indicatorsName: 'aot',
          resName: 'aot',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_AOT(min)'
          }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D1',
          resName: 'd1',
          indicatorsName: 'd1',
          resAvgName: '',
          name: formatMessage({
            id: 'pc_overview_daily_D1'
          }),
          rainbowKey: 'nightingale_d1',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D2',
          resName: 'd2',
          indicatorsName: 'd237',
          resAvgName: '',
          name: formatMessage({
            id: 'pc_overview_daily_D2'
          }),
          rainbowKey: 'nightingale_d2',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D3',
          resName: 'd3',
          indicatorsName: 'd3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D3'
          }),
          rainbowKey: 'nightingale_d3',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D4',
          resName: 'd4',
          indicatorsName: 'd4',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D4'
          }),
          rainbowKey: 'nightingale_d4',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'D5',
          resName: 'd5',
          indicatorsName: 'd5',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D5'
          }),
          rainbowKey: 'nightingale_d5',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D6',
          resName: 'd6',
          indicatorsName: 'd6',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D6'
          }),
          rainbowKey: 'nightingale_d6',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'D7',
          resName: 'd7',
          indicatorsName: 'd7',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_D7'
          }),
          rainbowKey: 'nightingale_d7',
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'In-Game Payer',
          indicatorsName: 'mtx_payers',
          resName: 'mtx_payers',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_Payer' }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'In-Game Payer%',
          indicatorsName: 'mtx_payer_rate',
          resName: 'mtx_payer_rate',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_Payer_Rate' }),
          isPercent: true,
          decimals: 2,
          dodDecimals: 1,
          avgName: '',
          isUserType: false,
        },
        {
          id: 'In-Game ARPU',
          indicatorsName: 'mtx_arpu',
          resName: 'mtx_arpu',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_ARPU' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'In-Game ARPPU',
          indicatorsName: 'mtx_arppu',
          resName: 'mtx_arppu',
          resAvgName: '',
          name: formatMessage({ id: 'pc_overview_MTX_ARPPU' }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'New Payer',
          resName: 'new_paid_users',
          indicatorsName: 'newPayer',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Payer'
          }),
          avgName: '',

          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Revenue(new payer)',
          resName: 'new_pay_amount',
          indicatorsName: 'revenue',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Revenue(new_payer)'
          }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'New Users ARPPU($)',
          resName: 'new_arppu',
          indicatorsName: 'newArppu',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_New_Users_ARPPU($)'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Sessions per user',
          resName: 'alc',
          indicatorsName: 'alc',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_Avg.Login_Count'
          }),
          avgName: '',
          isPercent: false,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'DAU Retention Users',
          resName: 'retention_users',
          indicatorsName: 'retentionUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_DAU_Retention_Users'
          }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Churn Users',
          resName: 'new_churn_users',
          indicatorsName: 'churnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Churn_Users'
          }),
          rainbowKey: 'nightingale_churn_user',
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'DAU Return Users',
          resName: 'return_users',
          indicatorsName: 'returnUsers',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_DAU_Return_Users'
          }),
          avgName: '',
          isPercent: false,
          decimals: 0,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'Weighted D2',
          resName: 'weighted_d2',
          indicatorsName: 'wd237',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D2'
          }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D3',
          resName: 'weighted_d3',
          indicatorsName: 'weightedD3',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D3'
          }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D7',
          resName: 'weighted_d7',
          indicatorsName: 'weightedD7',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D7'
          }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'Weighted D14',
          resName: 'weighted_d14',
          indicatorsName: 'weightedD14',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_Weighted_D14'
          }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: '1st Order Login%',
          resName: 'first_login_ratio',
          indicatorsName: 'firstLoginRatio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_1st_Order_Login%'
          }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: '2nd Order Login%',
          resName: 'second_login_ratio',
          indicatorsName: 'secondLoginRatio',
          resAvgName: '',
          name: formatMessage({
            id: 'overview_daily_2nd_Order_Login%'
          }),
          avgName: '',
          isPercent: true,
          decimals: 2,
          isUserType: false,
          dodDecimals: 1
        },
      ],
    }

    const metricsObj: any = {
      'mobile': mobileMetrics,
      'pc': pcMetrics,
      'nightingale': inflexionMetrics,
    }
    return metricsObj?.[pageShowType] || mobileMetrics
  }, [getLocale(), timeType, pageShowType])
  return topCardList[timeType];
}

export const useAccumulatedMetrics = (timeType = 'Day') => {
  const {
    formatMessage
  } = useIntl();
  const accumulatedMetrics: any = {
    Day: {
      id: 'DAU',
      indicatorsName: 'dau',
      resName: 'avg_dau',
      resAvgName: '',
      name: formatMessage({
        id: 'overview_monthly_Avg_DAU'
      }),
      avgName: '',
      isPercent: false,
      decimals: 0,
      isUserType: true,
      dodDecimals: 1
    },
    Week: {
      id: 'WAU',
      indicatorsName: 'dau',
      resName: 'avg_wau',
      resAvgName: '',
      name: formatMessage({
        id: 'overview_monthly_Avg_WAU'
      }),
      avgName: '',
      isPercent: false,
      decimals: 0,
      isUserType: true,
      dodDecimals: 1
    },
    Month: {
      id: 'MAU',
      indicatorsName: 'dau',
      resName: 'avg_mau',
      resAvgName: '',
      name: formatMessage({
        id: 'overview_monthly_Avg_MAU'
      }),
      avgName: '',
      isPercent: false,
      decimals: 0,
      isUserType: true,
      dodDecimals: 1
    },
  }
  return accumulatedMetrics[timeType] || [];
}

export const useLocalText = (config: { id: string; key: string; }[] = []) => {
  const { formatMessage } = useIntl();
  return useMemo(() => config.reduce((acc, item) => {
    acc[item.key] = formatMessage({ id: item.id });
    return acc;
  }, {}), [getLocale()])
}

export const useFunctionWithIntl = (localText, timeType, isAccumulated = false) => {
  const { selector } = useSelector(state => state?.dashboardSetting ?? {})
  const weekDayArr = useWeekDayArr()
  const { formatMessage } = useIntl();
  const DATE_COLUMN = {
    key: 'date',
    header: localText.date,
    width: isAccumulated ? 220 : 170,
    fixed: "left",
    align: "left",
    render(record:any) {
      /** Sum提示需要用到useState，
      *所以拿出来单独处理，
      *不然render里拿不到最新的的state
      */
      return <DateCell record={record} formatMessage={formatMessage} weekDayArr={weekDayArr} />;
    }
  }

  // 日期列, 周六日的颜色高亮 & Sum行增加提示
  function DateCell({ record, formatMessage, weekDayArr }) {
    const [isIconHover, setIsIconHover] = useState(false);
    const weekDay = getWeekDay(record.date, weekDayArr)?.slice(1, -1)
    const locale = getLocale()

    const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六'
    const showSumTip = record.date === 'Sum' || record.date === '汇总值';
    const displayDate = moment(record.date).isValid() === true ? moment(record.date).format("YYYY-MM-DD") : record.date;

    const renderedDate = (!!record.type || isAccumulated) ?
    (timeType === "Month" && record.date.includes('~') ?
      record.date.split('~').map(date => moment(date.trim()).format("YYYY-MM")).join('~') :
      record.date
    ) : (
      (timeType === "Month" ?
        moment(record.date).format("YYYY-MM") :
        (
          <>
            <span className='table-text'>{moment(record.date).format("YYYY-MM-DD")}</span>
            <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>
          </>
        )
      )
    );
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
         {renderedDate}
         <span style={{ display: 'inline-block', width: '0.4em' }}></span>
        {showSumTip && (
          <div className='port-item'>
            <div onMouseOver={() => { setIsIconHover(true) }} onMouseOut={() => { setIsIconHover(false) }} >
              <Bubble
                dark
                placement="top-start"
                arrowPointAtCenter
                style={{ maxWidth: locale === 'en-US' ? '235px' : '253px' }}
                content={formatMessage({ id: 'overview_sum_tip' })}
              >
                <div><SvgIcon className='port-icon' type={isIconHover ? 'alert-circle-action' : 'alert-circle-m'} /></div>
              </Bubble>
            </div>
          </div>
        )}
      </div>
    );
  }

  const CONTRAST_DATE_COLUMN = {
    key: 'contrast_date',
    header: `${localText['contrast']} ${localText.date}`,
    width: isAccumulated ? 220 : 170,
    fixed: "left",
    align: "left",
    render(record) {
      const weekDay = getWeekDay(record.contrast_date, weekDayArr)?.slice(1, -1)
      const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六'
      return isAccumulated ? 
      (
        timeType === "Month" && record.contrast_date && record.contrast_date.includes('~') ?
        record.contrast_date.split('~').map(date => moment(date.trim()).format("YYYY-MM")).join('~') : 
        (record.contrast_date || "")
      ) : (
        (
          (!record.contrast_date ?
            "" :
            (timeType === "Month" ?
              moment(record.contrast_date).format("YYYY-MM") :
              (
                <>
                  <span className='table-text'>{moment(record.contrast_date).format("YYYY-MM-DD")}</span>
                  <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>
                </>
              )
            )
          )
        )
      );
    

    }
  }



  // 获取维度列定义配置
  const getAccumulateColumns = (accumulates = [], gameCode: string) => {
    if (accumulates[0] === ACCUMULATED_DEFAULT_VALUE) return [];
    return accumulates?.filter(v => v !== 'date')?.map((value) => {
      const width = (value === 'region' || value === 'country') ? 260 : 200; // 设置不同的宽度
      return {
        key: value,
        header: localText[value],
        width: width,
        align: 'left',
        render(record) {
          let ImgDom: JSX.Element;
          try {
            ImgDom = <img style={{ width: '24px', height: '16px', marginRight: '8px', verticalAlign: 'middle' }} src={getCountryFlag(record.country === 'Total' ? 'Global' : record.country)} alt="flag" />;
          } catch (error) {
            ImgDom = <img style={{ width: '24px', height: '16px', marginRight: '8px', verticalAlign: 'middle' }} src={getCountryFlag('undefined')} alt="flag" />;
          }
          return (
            <>
              {
                record[value] ? (
                  <div className="obd-table-flex">
                    {value === 'country' && ImgDom}
                    <span>{getDynamicLocalCnEnText(value, record[value], gameCode, getLocale(), selector)}</span>
                  </div>
                ) : "-"
              }
            </>
          );
        }
      };
    });
  }
  

  const isEn = getLocale() === 'en-US'

  // 临时处理，修复之前开发展示不全或者展示太宽的问题，后期根据指标封装为公共方法
  const metricsWidthContrastObj:any = {
    'total_users': isEn ? 180 : 200,
    "new_users": 180,
    "avg_new_users": 250,
    "active_users": 200,
    "avg_active_users": 260,
    "pay_amount": isEn ? 250: 180,
    "avg_pay_amount": isEn ? 320 : 250,
    "pcu": isEn ? 180 : 200,
    "acu": isEn ? 180 : 200,
    "aot": isEn ? 280 : 260,
    "saot": isEn ? 330 : 270,
    "d1": 180,
    "d2": 180,
    "d3": 180,
    "d4": 180,
    "d5": 180,
    "d6": 180,
    "d7": 180,
    "paid_users": 180,
    "payer_rate": 200,
    "arpu": 210,
    "arppu": 220,
    "new_paid_users": 260,
    "new_pay_amount": isEn ? 340 : 220,
    "new_arppu": isEn ? 350 : 280,
    "alc": isEn ? 270 : 190,
    "retention_users": isEn ? 305 : 180,
    "churn_users": isEn ? 230 : 180,
    "churn_rate": 200,
    "return_users": isEn ? 290 : 180,
    'weighted_d2': 240,
    'weighted_d3': 240,
    'weighted_d7': 240,
    'weighted_d14': 250,
    'weighted_w2': 240,
    'weighted_w3': 240,
    'weighted_w4': 240,
    'weighted_m2': 240,
    'weighted_m3': 240,
    'weighted_m4': 240,
    'first_login_ratio': isEn ? 276 : 200,
    "second_login_ratio": isEn ? 290 : 200,
    "units_number": isEn ? 270 : 210,
    "units_revenue": isEn ? 280 : 200,
    "mtx_revenue": isEn ? 240 : 200,
    "dlc_revenue": isEn ? 240 : 200,
    "mtx_number": isEn ? 170 : 200,
    "mtx_dlc_arpu": isEn ? 270 : 270,
    "mtx_dlc_arppu": isEn ? 280 : 280,
    "digital_revenue": isEn ? 250 : 200,
    "physical_revenue": isEn ? 270 : 200,
    "avg_time_to_purchase": isEn ? 320 : 250,
  }
  const metricColumn:any = getMetricColumn()

  // 获取时间对比页面 指标列和指标对比列
  const getDateMetricColumns = (metricsValue: any = [], metricsObj, explainInfo, showType) => {
    const isShowUpDown = showType !== "value_only";
    return metricsValue.reduce((columns: any, value, index) => {
      const obj = metricsObj[value];
      const metric: any = metricColumn?.[value];
      const width = isShowUpDown ? metric?.width : metric?.onlyValueWidth;
      const contrastWidth = metricsWidthContrastObj?.[value];
      const explain = getExplainVal(explainInfo,obj?.rainbowKey, getLocale(), obj?.explainEn, obj?.explainCn);
      columns.push(
        {
          index,
          key: obj?.resName + showType,
          copyKey: obj?.resName,
          header: obj?.name,
          align: "right",
          explain,
          width: width || 230,
          isPercent: obj?.isPercent,
          render(record: { metrics: { [x: string]: {}; }; type: any; }) {
            const { value, change, } = record?.metrics?.[obj?.resName] || {};
            const isShowChange = showType !== "value_only";
            // record.type 有值的时候, 说明是汇总行, 指标列的状态是no
            return metricRender(value, change, obj, record.type, isShowChange);
          }
        },
        {
          index,
          key: `contrast_${obj?.resName}${showType}`,
          copyKey: `contrast_${obj?.resName}`,
          header: `${localText['contrast']} ${obj?.name}`,
          align: "right",
          width: contrastWidth || 230,
          explain: explain,
          isPercent: obj?.isPercent,
          copyConfig: {
            hideCopyChange: true,
          },
          render(record) {
            const { value, } = record?.metrics?.[`contrast_${obj?.resName}`] || {};
            return metricRender(value, undefined, obj, record.type, false);
          }
        }
      );
      return columns;
    }, []);
  }

  // 获取国家对比页面 指标列和指标对比列
  const getCountryMetricColumns = (metricsValue: any = [], metricsObj, explainInfo, showType) => {
    const isShowUpDown = showType !== "value_only";
    return metricsValue.reduce((columns: any, value) => {
      const obj = metricsObj[value];
      const metric: any = metricColumn?.[value];
      const width = isShowUpDown ? metric?.width : metric?.onlyValueWidth;
      const explain = getExplainVal(explainInfo,obj?.rainbowKey, getLocale(), obj?.explainEn, obj?.explainCn);
      columns.push(
        {
          key: obj?.resName + showType,
          copyKey: obj?.resName,
          header: obj?.name,
          align: "right",
          explain,
          width: width || 230,
          isPercent: obj?.isPercent,
          render(record) {
            const data = record?.metrics?.[obj?.resName] || {};
            const isShowChange = showType !== "value_only";
            // record.type 有值的时候, 说明是汇总行, 指标列的状态是no
            return metricRender(data.value, data[showType.replace("show_", "")], obj, record.type, isShowChange);
          }
        },
      );
      return columns;
    }, []);
  }

  // 获取夜莺时间对比页面 留存追踪对比宽表
  const getRetentionMetricColumns = (metricsValue: any = [], metricsObj, explainInfo, showType) => {
    const isShowUpDown = showType !== "value_only";
    return metricsValue.reduce((columns: any, value) => {
      const obj = metricsObj[value];
      const width = isShowUpDown ? 220 : 160
      const explain = obj?.explain ?? explainInfo?.[obj?.name]
      columns.push(
        {
          key: obj?.resName + showType,
          copyKey: obj?.resName,
          header: obj?.name,
          align: "right",
          explain,
          width: width || 220,
          isPercent: obj?.isPercent,
          render(record) {
            const data = record?.metrics?.[obj?.resName] || {};
            const isShowChange = showType !== "value_only";
            // record.type 有值的时候, 说明是汇总行, 指标列的状态是no
            return metricRender(data.value, data[showType.replace("show_", "")], obj, record.type, isShowChange);
          }
        },
      );
      return columns;
    }, []);
  }
  return {
    DATE_COLUMN,
    CONTRAST_DATE_COLUMN,
    getAccumulateColumns,
    getDateMetricColumns,
    getCountryMetricColumns,
    getRetentionMetricColumns,
  }
}

// 获取 宽表上方 Metrics筛选器的options
export const useMetricOptions = (metrics = [], getDefaultOnly = false) => {
  const [metricsValue, setMetricsValue] : any[] = useState([]);
  const [oldMetrics, setOldMetrics] : any[] = useState([]);
  const [oldMetricsValue, setOldMetricsValue] : any[] = useState([]);
  const [allMetrics, setAllMetrics] : any[] = useState([]);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const allMetricOptions = useMemo(() => {
    const allMetricOptions = metrics?.map((item: any) => {
      return {
        value: item.resName || item.value,
        text: item.name || item.text,
      }
    })
    const defaultMetricValue: any[] = [];
    for (let i = 0; i < allMetricOptions?.length; i++) {
      defaultMetricValue.push(allMetricOptions?.[i]?.value)
    }
    if(isFirstTime == true || getDefaultOnly == true){
      setOldMetrics(defaultMetricValue);
      setMetricsValue(defaultMetricValue);
      setAllMetrics(defaultMetricValue);
      setIsFirstTime(false);
    }else if(defaultMetricValue.filter(item => !oldMetrics.includes(item)).length > 0 || defaultMetricValue.length != oldMetrics.length){
      const different = metricsValue.filter((item: any) => !defaultMetricValue.includes(item));
      const differentFromAll = defaultMetricValue.filter(item => !allMetrics.includes(item));
      if(differentFromAll.length > 0){
        setAllMetrics(allMetrics.concat(differentFromAll));
        setMetricsValue(metricsValue.concat(differentFromAll));
      }
      if(different.length > 0){
        setOldMetricsValue(different);
      }
      setOldMetrics(defaultMetricValue);
    }
    return allMetricOptions
  }, [metrics, getLocale()]);
  return { metricsValue, setMetricsValue, allMetricOptions, oldMetrics, oldMetricsValue }
}


export function metricRender(
  value,
  percent,
  metric,
  type,
  isShowUpdown
) {
  const percentWidth = metric?.isPercent && type !== 'count' ? (value > 1 ? 100 : value * 100) : 0;
  const status = getUpAndDownStatus(percent, !!type);

  const percentStr = !!type ? '' : getVal(metric, percent, true)
  const formatValue = type === 'count' ? formatNum(value, false, true) : getVal(metric, value, false);
  return (<>
    <div className={"table-text-bg"} style={{ width: `${percentWidth}%` }} />
    <MetricAndUpDown
      metric={formatValue}
      updown={isShowUpdown ? { data: percentStr, status } : null}
      hasTooltip={false}
    />
  </>)

}
